export const PARAMETERS = {
  HostedZoneId: 'HostedZoneId',
  DomainName: 'DomainName',
  RepoOwner: 'RepoOwner',
  RepoName: 'RepoName',
  RepoBranch: 'RepoBranch',
  RepoToken: 'RepoToken',
  OpenAIAPIKey: 'OpenAIAPIKey',
  OpenAIModelId: 'OpenAIModelId',
  UserPoolSESARN: 'UserPoolSESARN',
  UserPoolSESDomainName: 'UserPoolSESDomainName',
  StripeEventSourceName: 'StripeEventSourceName',
  StripeAPIKey: 'StripeAPIKey',
  StripeEmployerPriceId: 'StripeEmployerPriceId',
};

export const STACK_IDS = {
  LocalUIDevelopmentDomainName: 'LocalUIDevelopmentDomainName',
  UserManagement: 'UserManagement',
  AdminGroup: 'AdminGroup',
  GroupAdminGroup: 'GroupAdminGroup',
  APICloudFunction: 'APICloudFunction',
  APICloudFunctionGateway: 'APICloudFunctionGateway',
  SSLCertificate: 'SSLCertificate',
  LiveUIFiles: 'LiveUIFiles',
  LiveAPIFiles: 'LiveAPIFiles',
  MainCDN: 'MainCDN',
  UIBuildPipeline: 'UIBuildPipeline',
  APIBuildPipeline: 'APIBuildPipeline',
  MainCDNCloudFront: 'MainCDNCloudFront',
  DatabaseMessageHistoryTable: 'DatabaseMessageHistoryTable',
  DatabaseUserInfoTable: 'DatabaseUserInfoTable',
  DatabaseUserProfileTable: 'DatabaseUserProfileTable',
  StripeEventBus: 'StripeEventBus',
  StripeCheckoutSessionCompletedRule: 'StripeCheckoutSessionCompletedRule',
  StripeEventBridgeInvokePermission: 'StripeEventBridgeInvokePermission',
};

export const USER_MANAGEMENT_ASSET_NAMES = {
  ROLE_NAMES: {
    AUTH: 'leadAdvisorHireCallingAuthRole',
    UNAUTH: 'leadAdvisorHireCallingUnauthRole',
  },
  GROUPS: {
    ADMIN: 'userManagementAdminGroup',
    GROUP_ADMIN: 'groupAdminGroup',
  },
};

export const INTERNAL_EVENT_CONFIG = {
  STRIPE: {
    ROLE: 'stripeEventBridge',
    PATH: '/stripe/event',
  },
};
